module.exports = __webpack_public_path__ + "web-assets/img/img_name.30dc46db.png";